export default "__VITE_ASSET__d4b0672d__"